<template>
  <div id="app">
    <waic-header v-if="!$route.meta.noHead || ($route.name === 'search' && searchListBoolean)"></waic-header>
    <keep-alive>
      <router-view v-if="!$route.meta.nokeep" />
    </keep-alive>
    <router-view v-if="$route.meta.nokeep" />
    <waic-footer v-if="!$route.meta.noHead"></waic-footer>
    <rightFix v-if="!$route.meta.noHead"></rightFix>
    <!-- <img style="position: absolute; left: 0; width: 100%; top: 0; height: auto; z-index: 9999; opacity: 0.4" src="../static/首页3.26.png" alt=""> -->
    <img src="https://static.worldaic.com.cn/2024/web/static/images/logo_121.png" style="position: absolute; left: 0; top: 0; pointer-events: none; opacity: 0;" alt="">
  </div>
</template>

<script>
import waicHeader from '@/components/head.vue'
import waicFooter from '@/components/foot.vue'
import rightFix from '@/components/rightFix.vue'
import protal from "@/api/protal";
export default {
  name: "App",
  components: {
    waicFooter,
    waicHeader,
    rightFix,
  },
  created() {
    protal.getConfigByCode('official_website').then(res => {
      const obj = res.data.data
      this.$store.commit('setLogo', obj.logoUrl ? obj.logoUrl : '')
      this.$store.commit('setPageTime', {
        "顶部-时间": obj.topTimeUrl,
        "顶部-时间-en": obj.topTimeUrlEn,
        "首页-头部-论坛": [obj.headForumName, obj.headForumTime, obj.headForumAddress],
        "首页-头部-论坛-en": [obj.headForumNameEn, obj.headForumTimeEn, obj.headForumAddressEn],
        "首页-头部-展览": [obj.headExhibitName, obj.headExhibitTime, obj.headExhibitAddress],
        "首页-头部-展览-en": [obj.headExhibitNameEn, obj.headExhibitTimeEn, obj.headExhibitAddressEn],
        "首页-往届回顾上面文案": obj.previousName,
        "首页-往届回顾上面文案-en": obj.previousNameEn
      }) 
      console.log({
        "顶部-时间": obj.topTimeUrl,
        "顶部-时间-en": obj.topTimeUrlEn,
        "首页-头部-论坛": [obj.headForumName, obj.headForumTime, obj.headForumAddress],
        "首页-头部-论坛-en": [obj.headForumNameEn, obj.headForumTimeEn, obj.headForumAddressEn],
        "首页-头部-展览": [obj.headExhibitName, obj.headExhibitTime, obj.headExhibitAddress],
        "首页-头部-展览-en": [obj.headExhibitName, obj.headExhibitTime, obj.headExhibitAddress],
        "首页-往届回顾上面文案": obj.previousName,
        "首页-往届回顾上面文案-en": obj.previousNameEn
      })
    })
    // protal.getJson('gw_time', data => {
    //   if (data) {
    //     console.log(JSON.stringify(data), 555)
    //     this.$store.commit('setPageTime', data)
    //   }
    // })
    this.getLabels()
    const langType = localStorage.getItem("lang");
    this.$store.commit("setLang", langType);
    
    protal.getZdCode("forum_type").then((res) => {
      if (res && res.data && res.data.length) {
        this.$store.commit('setForumType', res.data)
      }
    });
    this.getBanner()
  },
  mounted() {
    
  },
  watch: {
    successNum(v) {
      if ( this.$route.meta && this.$route.meta.num && v === this.$route.meta.num ) {
        this.$nextTick(() => {
          this.scrollTo()
        })
      }
    }
  },
  methods: {
    getLabels() {
      protal.getZdType("data_tag").then((res) => {
        if (res && res.data && res.data.length) {
          this.$store.commit('setLabels', res.data || [])
        }
		  });
    },
    getBanner() {
      // 获取banner底部
      protal.getOfficialFrontBanner().then((res) => {
        if (res && res.data) {
          this.$store.commit('setBanners', res.data || {})
        }
      });
    }
  }
};

</script>

<style lang="less">
@import url('~@/assets/font/font.less');

#app {
  font-family: "Source Han Sans CN", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  font-size: initial;
  transform-origin: left top;
}

*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

li,
ul {
  list-style: none;
}

.ellipsis1 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden !important;
}
.ellipsis2 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden !important;
}
.ellipsis3 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden !important;
}

.pub-btn-bg {
  background: url('https://static.worldaic.com.cn/2024/web/static/images/btn.png') !important;
  background-size: 100% 100% !important;
  background-color: transparent !important;
}

.zindex11 {
  position: relative;
  z-index: 11;
}

.title-line {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: .1rem;
    right: .1rem;
    top: 0;
    height: 2px;
    background-image: url('https://static.worldaic.com.cn/2024/web/static/images/title-line.png') !important;
    background-size: 100% 100%;
  }
}

.search-title-span {
  background: linear-gradient(126deg, RGBA(72, 138, 242, 1) 0%, RGBA(126, 92, 237, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media screen and (min-width: 769px) {
  body {

    &::-webkit-scrollbar {
      // width: 0;
    }

    // &::-webkit-scrollbar-thumb {
    //   background: rgba(0, 0, 0, .1);
    //   &:hover {
    //     background: rgba(0, 0, 0, .3);
    //   }
    // }
  }

  .vtext1 {
    * {
      display: inline;
      font-size: .2rem;
      line-height: .32rem;
      color: #727171 !important;
      font-weight: normal !important;
      background: none !important;
    }
  }

  .vtext2 {
    * {
      display: inline;
      font-size: .18rem;
      line-height: .28rem;
      color: #727171 !important;
      font-weight: normal !important;
      background: none !important;
    }
  }

  .pub-learn {
    width: auto;
    height: .18rem;
    cursor: pointer;
  }

  .wap {
    display: none !important;
  }

  .big-title {
    font-size: .48rem;
    color: #595757;
    line-height: 1;
    position: relative;
    font-family: sybold;
    height: .48rem;

    img {
      height: .48rem;
      width: auto;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: -0.32rem;
      width: .68rem;
      height: .12rem;
      background: url("https://static.worldaic.com.cn/2024/web/static/images/border-bottom.png");
      background-size: 100% 100%;
    }
  }

  .num-tupian {
    height: .32rem;
    width: auto;
    margin-right: .04rem;
  }

  .pub-title {
    height: .4rem;
    font-size: .4rem;
    font-weight: bold;
    color: #3E3A39;
    line-height: .4rem;
    text-align: center;

    span {
      display: inline-block;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -0.1rem;
        height: .16rem;
        background: linear-gradient(125deg, #2F9AF4 0%, rgba(195, 4, 226, 0.5) 100%);
        opacity: 0.2;
      }
    }
  }

  .el-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: .5rem;
    flex-wrap: wrap;

    button, .el-pager li {
      font-size: .26rem !important;
      background: none !important;
      font-weight: normal;
      color: #9E9F9F;
      padding: 0 .2rem;

      &.active {
        color: #595757;
      }

      .el-icon {
        font-size: .26rem !important;
      }
    }

    .el-pagination__jump {
      font-size: .2rem !important;
      color: #9E9F9F;
    }

    .el-input__inner, .el-pagination__editor, .el-pagination__jump {
      font-size: .2rem;
      height: .4rem !important;
    }
  }

  .vhtml {
    width: 100%;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    img, video {
      display: block;
      width: 100%;
      height: auto;
      margin: .2rem auto;
    }

    p {
      font-size: .18rem;
      line-height: .28rem;
      color: #3E3A39;

      strong {
        
      }
    }
  }

  .yingyong {
    padding: 1.65rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/chuangjian-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 15rem;
      margin: 0 auto;
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      margin-top: .67rem;
      width: calc(100% + 0.1rem);

      .flex-content {
        display: flex;
        flex-wrap: wrap;
      }

      .content-title {
        width: 15rem;
        height: 4rem;
        margin-bottom: .14rem;

        img {
          border-radius: .16rem;
        }
      }

      .item {
        position: relative;
        flex: 0 0 4.86rem;
        height: 4.64rem;
        border-radius: .16rem;
        background: #F6F7F7;
        margin-bottom: .24rem;
        margin-right: .21rem;
        cursor: pointer;

        &:nth-of-type(3n) {
          margin-right: 0;
        }

        .img {
          width: 4.86rem;
          height: 3.24rem;
          border-radius: .16rem;
          display: block;
        }

        .text {
          height: 1.4rem;
          padding: 0 .28rem;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .title {
            font-size: .22rem;
            font-weight: bold;
            color: #595757;
            line-height: .34rem;
            height: .68rem;
          }

          .addr {
            margin-top: .18rem;
            display: flex;
            align-items: center;
            font-size: .18rem;
            color: #595757;
            line-height: 1;
            justify-content: space-between;

            img {
              width: .2rem;
              height: .2rem;
              margin-right: .04rem;
            }
            
            .addr-item {
              display: flex;
              align-items: center;
            }
          }
        }
      }

      .item1 {
        height: 4.32rem;

        .text {
          height: 1.08rem;
        }

        .mask {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          height: 3.24rem;
          
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            border-radius: .16rem;
            background: linear-gradient(36deg, #005399 0%, #580067 100%);
            opacity: 0.6;
          }

          img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1rem;
            height: auto;
            cursor: pointer;
          }
        }
      }
    }

    .el-pagination {
      margin-top: .22rem;
    }

    .kongbai {
      height: 1.29rem;
    }

    .content1 {
      justify-content: flex-start;
      margin-top: 0;

      .item2 {
        flex: 0 0 3.6rem !important;
        height: 2.4rem;
        margin-right: .2rem;

        img {
          width: 100% !important;
          height: 100% !important;
        }

        &:nth-child(4n) {
          margin-right: 0;
        }

        &:nth-child(3n) {
          margin-right: .2rem;
        }
      }
    }

    .content2 {
      justify-content: space-between !important;
      
      .item {
        flex: 0 0 7.4rem;
        height: 1.68rem;
        display: flex;
        justify-content: center;
        padding: .28rem;
        margin-right: 0 !important;

        img {
          flex: 0 0 2.24rem !important;
          height: 1.12rem !important;
          border-radius: 0 !important;
          background: #fff;
          object-fit: contain;
          overflow: hidden;
        }

        .text {
          flex: 1;
          justify-content: center;
          height: auto;
          overflow: hidden;
          padding: 0 0 0 .28rem;
          
          .title {
            font-size: .22rem;
            color: #595757;
            line-height: .36rem;
            font-weight: normal;
            font-family: sybold;
          }
        }
      }
    }

    .content3 {

      .item {
        height: 4.92rem;

        .text {
          height: 1.68rem;

          .small {
            font-size: .18rem;
            font-weight: 400;
            color: #656565;
            line-height: .26rem;
            height: .52rem;
            margin-top: .16rem;
          }
        }
      }
    }

    .content4 {

      .item {
        height: 4.14rem;

        .text {
          height: .9rem;

          .title {
            height: auto;
            font-weight: normal;
            font-family: sybold;
          }
        }
      }
    }

    .content6 {

      .item {

        .addr {
          justify-content: flex-start !important;
        }
      }
    }

  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .pc {
    display: none !important;
  }

  .vtext1 {
    * {
      display: inline;
      font-size: .22rem;
      line-height: .34rem;
      color: #727171 !important;
      font-weight: normal !important;
      background: none !important;
    }
  }

  .vtext2 {
    * {
      display: inline;
      font-size: .2rem;
      line-height: .28rem;
      color: #727171 !important;
      font-weight: normal !important;
      background: none !important;
    }
  }

  .pub-learn {
    width: 1.17rem;
    height: auto;
    cursor: pointer;
  }

  .big-title {
    font-size: .4rem;
    color: #595757;
    line-height: 1;
    position: relative;
    font-weight: bold;
    height: .4rem;

    img {
      height: .44rem;
      width: auto;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: -0.34rem;
      width: .64rem;
      height: .12rem;
      background: url("https://static.worldaic.com.cn/2024/web/static/images/border-bottom.png");
      background-size: 100% 100%;
    }
  }

  .num-tupian {
    height: .3rem;
    width: auto;
    margin-right: .03rem;
  }

  .pub-title {
    font-size: .4rem;
    font-weight: bold;
    color: #3E3A39;
    line-height: 1;
    text-align: center;

    span {
      display: inline-block;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -0.1rem;
        height: .16rem;
        background: linear-gradient(125deg, #2F9AF4 0%, rgba(195, 4, 226, 0.5) 100%);
        opacity: 0.2;
      }
    }
  }

  .el-pagination {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: .65rem;

    button, .el-pager li {
      font-size: .32rem !important;
      background: none !important;
      font-weight: normal;
      color: #9E9F9F !important;
      padding: 0 .1rem;

      &.active {
        color: #595757 !important;
      }

      .el-icon {
        font-size: .32rem !important;
      }
    }

    .el-pagination__jump {
      font-size: .24rem !important;
      color: #9E9F9F;
    }

    .el-input__inner, .el-pagination__editor, .el-pagination__jump {
      font-size: .24rem;
      height: .48rem !important;
    }
  }

  .vhtml {
    width: 100%;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    img, video {
      display: block;
      width: 100%;
      height: auto;
      margin: .2rem auto;
    }

    p {
      font-size: .26rem;
      line-height: .36rem;
      color: #3E3A39;

      strong {
        
      }
    }
  }
  
  .yingyong {
    width: 100%;
    padding: 1.57rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/wap-bg.jpg);
    background-size: 100% auto;
    overflow: hidden;

    .inner {
      width: 6.86rem;
      margin: 0 auto;
    }

    .pub-title {
      margin-bottom: .47rem;
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .flex-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .content-title {
        width: 100%;
        height: 1.83rem;
        border-radius: .16rem;
        margin-bottom: .24rem;
        object-fit: cover;
      }

      .item {
        position: relative;
        flex: 0 0 3.32rem;
        height: 3.9rem;
        border-radius: .16rem;
        background: #F6F7F7;
        margin-bottom: .22rem;

        .img {
          width: 3.32rem;
          height: 2.2rem;
          border-radius: .16rem;
          display: block;
        }

        .text {
          height: 1.48rem;
          padding: .1rem .16rem 0;

          .title {
            font-size: .26rem;
            font-weight: bold;
            color: #595757;
            line-height: .36rem;
            height: .66rem;
          }

          .addr {
            margin-top: .1rem;
            font-size: .22rem;
            color: #595757;
            line-height: .32rem;
            justify-content: space-between;

            img {
              width: .24rem;
              height: .24rem;
              margin-right: .02rem;
            }
            
            .addr-item {
              display: flex;
              align-items: center;
            }
          }
        }
      }

      .item1 {
        height: 3.28rem;

        .text {
          height: 1.08rem;
        }

        .mask {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          height: 2.2rem;
          
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            border-radius: .16rem;
            background: linear-gradient(36deg, #005399 0%, #580067 100%);
            opacity: 0.6;
          }

          img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1rem;
            height: auto;
            cursor: pointer;
          }
        }
      }
    }

    /deep/ .el-pagination {
      margin-top: .32rem;
    }

    .kongbai {
      height: 1.25rem;
    }

    .content1 {
      justify-content: flex-start;
      margin-top: 0;

      .item2 {
        flex: 0 0 3.32rem !important;
        height: 2.21rem;
        margin-right: .2rem;

        img {
          width: 100% !important;
          height: 100% !important;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }

    .content2 {
      
      .item {
        flex: 1;
        height: 1.66rem;
        display: flex;
        justify-content: center;
        padding: .28rem;

        img {
          flex: 0 0 2.2rem !important;
          height: 1.1rem !important;
          border-radius: 0 !important;
          background: #fff;
          object-fit: contain;
          overflow: hidden;
        }

        .text {
          justify-content: flex-start;
          height: auto;
          overflow: hidden;
          padding: 0 0 0 .28rem;
          
          .title {
            font-size: .26rem;
            color: #595757;
            line-height: .36rem;
            font-weight: normal;
            font-family: sybold;
          }
        }
      }
    }

    .content3 {

      .item {
        height: 4.1rem;

        .text {
          height: 1.88rem;

          .small {
            font-size: .22rem;
            font-weight: 400;
            color: #656565;
            line-height: .36rem;
            height: .72rem;
            margin-top: .16rem;
          }
        }
      }
    }

    .content4 {

      .item {
        height: 3.12rem;

        .text {
          height: .92rem;
          padding-top: 0;
          display: flex;
          align-items: center;

          .title {
            height: auto;
            font-weight: normal;
            font-family: sybold;
          }
        }
      }
    }

    .content6 {

      .item {
        height: 3.66rem;

        .text {
          height: 1.44rem;

          .title {
            height: auto;
            font-weight: normal;
            font-family: sybold;
          }

          .addr {
            display: flex;
            align-items: center;
            justify-content: flex-start !important;
          }
        }
      }
    }

    .el-pagination {
      margin-top: .34rem !important;
    }

  }

  .title-line {

    &::before {
      height: 1px;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/App.vue